// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I5xS","footer":"styles_footer__oO2zX"};